import { useEffect } from 'react';
import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { SarlaftFormProps } from './props';
import { SarlaftForm } from '../../../../../../shared/types/modules/sarlaft';

export const useSarlaftForm = ({
    data,
    onChangeData,
    onChangeFormik,
}: SarlaftFormProps) => {
    const onSubmit = (data: SarlaftForm) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue('numberForm', data?.numberForm || '');
    }, [data]);

    return {
        formik,
    };
};
